export enum AppointmentState {
  Pending,
  Approved,
  Rejected,
}
